<template>
<div class="login-box">
    <span class="title">供应链主营系统</span>
    <h1>登录</h1>
      <a-form
    id="components-form-demo-normal-login"
    :form="form"
    class="login-form"
    @submit="handleSubmit"
  >
  <a-alert v-if="flag" message="手机号/密码错误" type="error" show-icon closable  :after-close="onClose" />
    <a-form-item>
      <a-input
      @focus="onFocus"
      allowClear
        v-decorator="[
          'account',
          { 
            validateTrigger:'blur',
            rules: [
              { required: true, message: '请输入手机号码' },
              { pattern: /^1[3456789]\d{9}$/, message: '请输入正确手机号码'}
            ]
          },
        ]"
        placeholder="手机号"
      >
        <a-icon slot="prefix" type="mobile" style="color: rgba(0,0,0,.25)" />
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-input
       @focus="onFocus"
      allowClear
        v-decorator="[
          'rawPwd',
          { 
            validateTrigger:'blur',
           rules: [
            { required: true, message: '请输入密码' },
            { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/, message: '请输入合法字符，字母/数字至少包含2种'}
          ] },
        ]"
        type="password"
        placeholder="密码"
      >
        <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" html-type="submit" class="login-form-button">
        登 录
      </a-button>
    </a-form-item>
  </a-form>
</div>

</template>

<script>
export default {
  name:'login',
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'normal_login' });
  },
  data(){
    return {
      flag:false,
    }
  },
  computed:{
  },
  methods: {
    onFocus(){
      this.flag =false;
    },
    onClose(e) {
      this.flag = false;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$http.post('signin','',{params:values}).then(res=>{
            if (res.code=='510102') {
              this.flag = true;
              this.$message.warning(res.message)
            }else if (res.code=='200001') {
              localStorage.setItem("account",res.data.account);
              localStorage.setItem("id",res.data.id);
               this.$store.commit('handleUserName',res.data.alias);
              this.$router.push({name:'sub-account-no'})
            }
          })
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.login-box{
    .title{
        height:24px;
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(0,0,0,0.4);
        line-height:24px;
    }
    h1{
        height:40px;
        font-size:32px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(0,0,0,0.8);
        line-height:40px;
    }
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
#components-form-demo-normal-login{
  width: 368px;
}
#components-form-demo-normal-login .login-form-forgot {
  float: right;
}
#components-form-demo-normal-login .login-form-button {
  width: 100%;
}
.ant-alert-error{
  margin-bottom: 16px;
}
</style>